var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{ref:"accuterm",style:(_vm.style),attrs:{"id":"terminal","autofocus":""}}),_c('audio',{ref:"beep",attrs:{"id":"beep"}},[_c('source',{attrs:{"src":require("@/vendor/accuterm/client/sound/beep.mp3")}})])])}
var staticRenderFns = []

export { render, staticRenderFns }